import React from 'react';
import { motion } from 'framer-motion';

const Step = ({ number, title, description, delay }) => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.5, delay }}
    className="bg-white rounded-2xl p-6 shadow-soft border border-dc-teal-deep/5 relative"
  >
    <div className="absolute -top-3 -left-3 w-10 h-10 bg-dc-teal-deep rounded-full flex items-center justify-center text-white font-display font-bold text-sm">
      {number}
    </div>
    <h3 className="text-lg font-semibold text-dc-teal-deep mb-2 mt-2">{title}</h3>
    <p className="text-dc-text/70 text-sm leading-relaxed">{description}</p>
  </motion.div>
);

const HowItWorks = () => {
  return (
    <section className="py-16 px-6 max-w-5xl mx-auto">
      <motion.h2
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
        className="text-2xl md:text-3xl font-bold text-dc-teal-deep text-center mb-12"
      >
        How the Memberships Work
      </motion.h2>
      
      <div className="grid md:grid-cols-3 gap-6">
        <Step 
          number="1"
          title="Choose your level"
          description="Start with the briefing to stay informed, or choose Build Your Network for industry rooms, directory presence, and deeper guidance."
          delay={0}
        />
        <Step 
          number="2"
          title="Review your reputation"
          description="Both memberships include a free RepUpgrade Reputation Report to see how your business shows up online."
          delay={0.1}
        />
        <Step 
          number="3"
          title="Move through the ecosystem"
          description="Briefing members stay informed through the core rhythm. Build Your Network members use rooms, channels, and directory presence to build momentum."
          delay={0.2}
        />
      </div>
    </section>
  );
};

export default HowItWorks;